module.exports = __webpack_public_path__ + "static/media/luminary.edeac637.png";